export default "__VITE_ASSET__Di_V51Su__"